import React from "react";
import "./App.css";
import "./index.css";
import "./components/common_component/common_css/Common_Form_Css.css";

import { Route, Routes } from "react-router-dom";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import About_Us from "./components/about-us/About_Us";
import Contact_Us from "./components/contact-us/Contact_Us";
import PrivacyPolicy from "./components/privacy_policy/Privacy_Policy";
import Terms_Conditions from "./components/home/terms_conditions/Terms_Conditions";
import Location from "./components/location/Location";
import Argentina from "./components/location/argentina/Argentina";
import CityBreak from "./components/home/holidays/city-break/City_Break";
import GetFreeCruise from "./components/cruises/get-free-cruise/Get_Free_Cruise";
import Cruises from "./components/cruises/Cruises";
import Cruise_Details from "./components/cruises/cruise-details/Cruise_Details";
import Location_Inner_Page from "./components/location/location-inner-page/Location_Inner_Page";

function App() {
  return (
    <>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_Us />} />
        <Route path="/contact-us" element={<Contact_Us />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<Terms_Conditions />} />
        {/* <Route path="/location" element={<Location />} /> */}
        <Route path="/location/argentina" element={<Argentina />} />
        <Route path="/location/:id" element={<Argentina />} />
        <Route path="home/holidays/city-break/:id" element={<CityBreak />} />
        <Route path="/cruises" element={<Cruises />} />

        <Route path="/cruise-details/:id" element={<Cruise_Details />} />
        <Route
          path="/location-inner-page/:id"
          element={<Location_Inner_Page />}
        />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
